import type { z } from 'zod';

export class ErreurApi extends Error {
  constructor(
    public readonly statut: number,
    public readonly code: string,
  ) {
    super(`API ${statut} ${code}`);
  }
}

/** GET JSON sur l'API, avec validation du corps par le schéma partagé de `@carte/contrats`. */
export async function obtenir<S extends z.ZodType>(
  chemin: string,
  schema: S,
  parametres?: URLSearchParams,
): Promise<z.infer<S>> {
  const suffixe = parametres && [...parametres].length > 0 ? `?${parametres}` : '';
  const reponse = await fetch(`${chemin}${suffixe}`, { credentials: 'same-origin' });
  if (!reponse.ok) {
    const corps = (await reponse.json().catch(() => ({}))) as { erreur?: string };
    throw new ErreurApi(reponse.status, corps.erreur ?? 'erreur');
  }
  return schema.parse(await reponse.json());
}
